import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Button as ButtonMemoized } from '../Button/Button.js';
import { Card as CardMemoized } from '../Card/Card.js';
import { Icon } from '../Icon/Icon.js';
import { Image as ImageMemoized } from '../Image/Image.js';
import { Typography } from '../Typography/Typography.js';

var _excluded = ["title", "description", "closeButton", "actions", "asset", "onClose", "contentAlignment"],
  _excluded2 = ["onClick"];
function isImage(asset) {
  return !!(asset && asset.src);
}
var Banner = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    description = _ref.description,
    closeAction = _ref.closeButton,
    actions = _ref.actions,
    asset = _ref.asset,
    onClose = _ref.onClose,
    contentAlignment = _ref.contentAlignment,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isClosed = _React$useState2[0],
    setClosed = _React$useState2[1];
  var assetElement = React.useMemo(function () {
    return asset && (isImage(asset) ? /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexShrink: 0,
      width: "80px",
      qM: {
        width: '190px'
      }
    }, /*#__PURE__*/React.createElement(ImageMemoized, {
      src: asset.src,
      alt: asset.alt,
      loading: "lazy",
      objectFit: "cover",
      height: "100%",
      responsive: "manual",
      requestWidth: 80,
      qM: {
        requestWidth: 190
      }
    })) : /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "start",
      p: "8",
      pe: "0",
      qM: {
        alignItems: 'center',
        p: '12',
        pe: '0'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      id: asset.id,
      color: asset.color,
      size: asset.size || '20',
      label: asset.label
    })));
  }, [asset]);
  var actionElement = React.useMemo(function () {
    if (!actions) return null;
    var _actions = _slicedToArray(actions, 2),
      primary = _actions[0],
      secondary = _actions[1];
    return /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexShrink: 1,
      flexDirection: "row-reverse",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      order: 1,
      p: "8",
      pt: "0",
      qM: {
        width: 'auto',
        order: 0,
        p: '12',
        py: '0'
      }
    }, primary, secondary && /*#__PURE__*/React.createElement(Box, {
      me: "8",
      qM: {
        me: '12'
      }
    }, secondary));
  }, [actions]);
  var closeElement = React.useMemo(function () {
    if (!closeAction) return null;
    var _ref2 = closeAction === true ? {} : closeAction,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? undefined : _ref2$onClick,
      attrs = _objectWithoutProperties(_ref2, _excluded2);
    var onClickClose = function onClickClose(event) {
      onClick === null || onClick === void 0 || onClick(event);
      onClose === null || onClose === void 0 || onClose();
      setClosed(true);
    };
    return /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "start",
      qM: {
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(ButtonMemoized, _extends({}, attrs, {
      "aria-label": "close",
      onClick: onClickClose,
      variant: "icon",
      leadingIcon: "line.symbol.close",
      hierarchy: "tertiary",
      size: "m",
      my: "12",
      me: "12"
    })));
  }, [closeAction, onClose]);
  if (isClosed) return null;
  var bannerCardProps = {
    forwardedAs: 'section',
    display: 'flex',
    alignItems: 'stretch',
    overflow: 'hidden',
    type: 'non-interactive',
    variant: 'outlined'
  };
  return /*#__PURE__*/React.createElement(CardMemoized, _extends({}, rest, {
    ref: ref
  }, bannerCardProps), assetElement, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexGrow: 1,
    flexWrap: "wrap",
    qM: {
      flexWrap: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1,
    flexBasis: 0,
    p: "8",
    qM: {
      p: '12'
    },
    alignSelf: contentAlignment
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s-strong"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s"
  }, description)), actionElement, closeElement));
});
var BannerMemoized = /*#__PURE__*/React.memo(Banner);
BannerMemoized.displayName = 'Banner';

export { BannerMemoized as Banner };
//# sourceMappingURL=Banner.js.map
